import { makeStyles, Typography } from '@material-ui/core'
import { FC } from 'react'
import isEmpty from 'lodash/isEmpty'
import { VictoryPie, VictoryTooltip } from 'victory'
import useTranslate from '../../../i18n/useTranslate'
import { ResponseInprogress } from '../../../services/um/useDashboard'
import EmptyData from '../officer/EmptyData'

interface InProgressProps {
    data: ResponseInprogress[]
}

const InProgress: FC<InProgressProps> = ({ data }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const dataPie = data.map((item) => {
        return {
            x: item.id,
            y: item.value,
            name: item.label[lang],
        }
    })

    const dataLegend = data.map((item) => {
        return {
            id: item.id,
            name: item.label[lang],
            fill: item.color[0],
        }
    })

    const pieColor = data.map((item) => {
        return (
            <svg viewBox="0 0 0  0" height={0} width={0}>
                <defs>
                    <radialGradient id={`gradient${item.id}`} cx="90%" cy="90%" r="100%">
                        <stop offset="0%" stopColor={item.color[0]} />
                        <stop offset="100%" stopColor={item.color[0]} />
                    </radialGradient>
                </defs>
            </svg>
        )
    })

    const isValue = Object.values(data).every((item) => item.value === 0 || item.value === null)

    return (
        <>
            <Typography className={classes.header}>{translate.get('UM.DASHBOARD.ÏN_PROGRESS')}</Typography>

            <div className={classes.chart}>
                <EmptyData isEmpty={isEmpty(data) || isValue}>
                    <VictoryPie
                        labels={() => ''}
                        labelComponent={
                            <VictoryTooltip x={90} y={165} flyoutComponent={<CustomLabel renderInPortal={false} />} />
                        }
                        innerRadius={110}
                        radius={170}
                        data={dataPie}
                        colorScale={[`url(#gradient1)`, `url(#gradient2)`, `url(#gradient3)`]}
                        events={[
                            {
                                target: 'data',
                                eventHandlers: {
                                    onMouseOver: () => {
                                        return [
                                            {
                                                target: 'data',
                                                mutation: () => ({ radius: 190 }),
                                            },
                                            {
                                                target: 'labels',
                                                mutation: () => ({ active: true }),
                                            },
                                        ]
                                    },
                                    onMouseOut: () => {
                                        return [
                                            {
                                                target: 'data',
                                                mutation: () => null,
                                            },
                                            {
                                                target: 'labels',
                                                mutation: () => null,
                                            },
                                        ]
                                    },
                                },
                            },
                        ]}
                        padding={0}
                    />

                    {pieColor}
                </EmptyData>
            </div>
            {isEmpty(data) || isValue ? null : (
                <div className={classes.legend}>
                    {dataLegend.map((item) => {
                        return (
                            <div
                                style={{
                                    display: 'inline-flex',
                                    margin: '0px 8px',
                                }}
                                key={item.id}
                            >
                                <svg
                                    height="16"
                                    width="16"
                                    style={{ margin: 'auto 8px', minHeight: '24px', minWidth: '24px' }}
                                >
                                    <circle cx="50%" cy="50%" r="8" stroke="none" fill={item.fill} />
                                </svg>
                                <p style={{ margin: 'auto 0', fontSize: '16px' }}>{item.name}</p>
                            </div>
                        )
                    })}
                </div>
            )}
        </>
    )
}

const CustomLabel = ({ x, y, datum }: any) => {
    const translate = useTranslate()
    const classes = useStyles()
    return (
        <g style={{ pointerEvents: 'none' }}>
            <foreignObject
                x={x - 115}
                y={y - 20}
                height="300"
                width="450"
                style={{
                    border: 'none',
                    display: 'inline-block',
                }}
            >
                <div className={classes.legend}>
                    <Typography className={classes.tooltipLabel} variant="h5">
                        {datum.name}
                    </Typography>
                    <Typography className={classes.tooltipLabel} variant="h3">
                        {datum.y}
                    </Typography>
                    <Typography className={classes.tooltipLabel} variant="h5">
                        {translate.get('UM.DASHBOARD.UNIT_PROJECT')}
                    </Typography>
                </div>
            </foreignObject>
        </g>
    )
}

const useStyles = makeStyles(() => ({
    chart: {
        width: '300px',
        height: '312px',
        margin: 'auto',
        display: 'block',
    },
    legend: {
        width: '100%',
        textAlign: 'center',
    },
    tooltipContainer: {
        position: 'relative',
        textAlign: 'center',
    },
    tooltipLabel: {},
    header: {
        margin: '0px 8px',
        fontWeight: 'bold',
    },
}))

export default InProgress
